import React from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import getSlides from '../../functions/getSlides/getSlides';
import ThemeNineTitle from '../common/ThemeNineTitle';

const ThemeNineFrequentPassengersScreen = props => {
  return (
    <div className="themes-nine-frequent-passengers-screen">
      <KuposHelmet />

      <div style={{ position: 'relative', marginTop: -20 }}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('frequentPassengerBanner')}
          title={'Pasajero frecuente '}
          description={'Home / Pasajero frecuente '}
        />
      </div>

      <div className="frequent-passenger-container">
        <ThemeNineTitle title={'Pasajero frecuente y Estudiante año 2022'} />

        <div className='passenger-info'>
          <span className='dot'></span>
          <span>Recuerde renovar su <span className='bold-text'> PASE DE PASAJERO FRECUENTE Y/O ESTUDIANTE </span>  antes de la fecha de vencimiento estipulada en la credencial. </span>
        </div>

        <div className='passenger-info mt-20'>
          <span className='dot'></span>
          <span>Proceso de pase nuevo y renovación se realiza directamente en la página web de Buses Ahumada haciendo <a href='http://200.111.102.206/Solicitud/registro.aspx' target='_blank' > clic aquí </a>  </span>
        </div>

        <div className='documents-required'>
          <span>Documentos requeridos</span>
        </div>

        <div className='pass-details-container'>
          <div className='new-pass'>
            <div>
              <ThemeNineTitle title="Pase nuevo" />
            </div>
            <div>

              <div className='passenger-info'>
                <span className='dot'></span>
                <span>Valor de <span className='bold-text'> CLP $2.000 </span> y se cancela al momento de retirar el pase en terminal seleccionado.  </span>
              </div>

              <div className='passenger-info mt-20'>
                <span className='dot'></span>
                <span> Documento que acredite el <span className='bold-text'>viaje frecuente</span>  en formato JPG o PDF.  </span>
              </div>

              <div className='passenger-info mt-20'>
                <span className='dot'></span>
                <span>Registro online <a href='http://200.111.102.206/Solicitud/registro.aspx' target='_blank' > clic aquí </a>  </span>
              </div>

            </div>
          </div>
          <div className='renew-pass'>
            <div>
              <ThemeNineTitle title="Renovación de pase" />
            </div>
            <div>

              <div className='passenger-info'>
                <span className='dot'></span>
                <span>Valor de <span className='bold-text'> CLP $2.000 </span> y se cancela al momento de retirar el pase en terminal seleccionado.  </span>
              </div>

              <div className='passenger-info mt-20'>
                <span className='dot'></span>
                <span> Documento que acredite el <span className='bold-text'>viaje frecuente</span>  en formato JPG o PDF.  </span>
              </div>

              <div className='passenger-info mt-20'>
                <span className='dot'></span>
                <span>Registro online <a href='http://200.111.102.206/Solicitud/registro.aspx' target='_blank' > clic aquí </a>  </span>
              </div>

            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineFrequentPassengersScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineFrequentPassengersScreen.js